import { Trophy, Crown, Medal, Star, X, Users } from 'lucide-react'
import './Leaderboard.css'

export default function Leaderboard({ players, currentPlayerId, onClose }) {
  // Sort players by score (descending)
  const sortedPlayers = [...players].sort((a, b) => (b.score || 0) - (a.score || 0))
  
  const getRankIcon = (index) => {
    switch (index) {
      case 0: return <Crown size={20} className="rank-icon gold" />
      case 1: return <Medal size={20} className="rank-icon silver" />
      case 2: return <Medal size={20} className="rank-icon bronze" />
      default: return <Star size={16} className="rank-icon" />
    }
  }
  
  const getRankClass = (index) => {
    if (index === 0) return 'rank-1'
    if (index === 1) return 'rank-2'
    if (index === 2) return 'rank-3'
    return ''
  }

  return (
    <div className="leaderboard-overlay" onClick={onClose}>
      <div className="leaderboard-modal" onClick={e => e.stopPropagation()}>
        <div className="leaderboard-header">
          <div className="leaderboard-title">
            <Trophy size={28} className="title-icon" />
            <h2>Live Leaderboard</h2>
          </div>
          <button className="close-btn" onClick={onClose}>
            <X size={24} />
          </button>
        </div>
        
        <div className="leaderboard-content">
          <div className="players-count">
            <Users size={16} />
            <span>{players.length} Players</span>
          </div>
          
          <div className="leaderboard-list">
            {sortedPlayers.map((player, index) => (
              <div 
                key={player.id} 
                className={`leaderboard-item ${getRankClass(index)} ${player.id === currentPlayerId ? 'current-player' : ''}`}
              >
                <div className="player-rank">
                  {getRankIcon(index)}
                  <span className="rank-number">#{index + 1}</span>
                </div>
                
                <div className="player-info">
                  <span className="player-name">
                    {player.name}
                    {player.id === currentPlayerId && (
                      <span className="you-tag">YOU</span>
                    )}
                  </span>
                  
                  <div className="player-stats">
                    <span className="player-stage">Stage {player.stage + 1 || 1}</span>
                    {player.combo > 1 && (
                      <span className="player-combo">🔥 x{player.combo}</span>
                    )}
                  </div>
                </div>
                
                <div className="player-score">
                  <span className="score-value">{(player.score || 0).toLocaleString()}</span>
                  <span className="score-label">pts</span>
                </div>
              </div>
            ))}
          </div>
          
          {sortedPlayers.length === 0 && (
            <div className="no-players">
              <p>Waiting for players to join...</p>
            </div>
          )}
        </div>
        
        <div className="leaderboard-footer">
          <p>Scores update in real-time</p>
        </div>
      </div>
    </div>
  )
}
